export const storm = '#180D43';

export const white = '#ffffff';

export const secondary = {
    contrastText: white,
    main: '#1e90ff',
    hover: '#2b69a7',
};

export const primary = {
    contrastText: white,
    main: '#1e90ff',
    hover: '#2b69a7',
};

export const tertiary = {
    contrastText: white,
    main: storm,
};

//const intervals = [10, 20, 40, 60, 80, 90, 100];

export default {
    name: 'osano-admin',
    tokens: {
        colors: {
            font: {
                primary: { value: primary.main },
                secondary: { value: secondary.main },
                tertiary: { value: tertiary.main },
                interactive: { value: primary.main },
            },
        },
        components: {
            heading: {
                color: { value: tertiary.main },
            },
            authenticator: {
                router: {
                    border: {
                        value: 'none',
                    },
                    boxShadow: {
                        value: 'none',
                    },
                },
                state: {
                    inactive: {
                        color: {
                            value: white,
                        },
                        backgroundColor: {
                            value: tertiary.main,
                        },
                    },
                },
            },
            button: {
                fontWeight: { value: '{fontWeights.extrabold}' },
                link: {
                    backgroundColor: { value: 'transparent' },
                    textDecoration: { value: `underline rgba(55, 205, 143, 0.4)` },
                    _hover: {
                        color: { value: primary.main },
                        backgroundColor: { value: 'transparent' },
                        textDecoration: { value: `inherit` },
                    },
                },
                _hover: {
                    backgroundColor: { value: primary.main },
                    color: { value: primary.contrastText },
                    borderColor: { value: primary.main },
                },
                _focus: {
                    backgroundColor: { value: primary.main },
                    color: { value: primary.contrastText },
                    borderColor: { value: primary.main },
                    outlineColor: { value: primary.main },
                },
                _active: {
                    backgroundColor: { value: primary.main },
                    color: { value: primary.contrastText },
                    borderColor: { value: primary.main },
                },
                primary: {
                    backgroundColor: { value: primary.main },
                    color: { value: primary.contrastText },
                    _hover: {
                        backgroundColor: { value: primary.hover },
                        boxShadow: `rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px`,
                    },
                    _focus: {
                        backgroundColor: { value: primary.hover },
                    },
                    _active: {
                        backgroundColor: { value: primary.hover },
                    },
                },
            },
            textfield: {
                color: { value: 'inherit' },
            },
            // tabs: {
            //     item: {
            //         color: {
            //             value: white,
            //         },
            //         _focus: {
            //             color: {
            //                 value: white,
            //             },
            //         },
            //         _hover: {
            //             color: {
            //                 value: white,
            //             },
            //         },
            //         _active: {
            //             color: {
            //                 value: white,
            //             },
            //             backgroundColor: {
            //                 value: secondary.main,
            //             },
            //         },
            //     },
            // },
        },
    },
};
